import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/Container";
import Offcanvas from "react-bootstrap/Offcanvas";
import constant, { AgentStatusKeyValue } from "../../core/constant";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../core/redux/hooks";
import "./NavigationBar.css"
import {
    clearAuthSlice,
    setPreventNavigation,
} from "../../core/redux/authSlice";
import {
    getSettingsDetails,
    disconnectWebSocketConnection,
    DisplayToaster,
    loggerHelper
} from "../../core/services/sharedService";
import Badge from "react-bootstrap/Badge";
import rcmlogo from "../../assets/rcmlogo.png";
import { DtoSettingsLinks, DtoLinks } from "../../core/dto/settings.dto";
import Button from "react-bootstrap/esm/Button";
import { NavigationBarDto } from "../../core/dto/navigationBar.dto";
import AppModal from "../AppModal/AppModal";
import { DtoIncomingNotification, DtoLocationDetails } from "../../core/dto/dashboard.dto";
import { setAudioOutputDeviceChanged, setMissedCallNotificationTrigger, setVoiceMailNotificationTrigger } from "../../core/redux/notificationsSlice";
import { Card } from "react-bootstrap";
import DeviceChoice from "../Settings/DeviceChoice";
import { GetApiMethod } from "../../core/services/apiService";

const notificationDetails = (notification: DtoIncomingNotification, locations: { [index: string]: DtoLocationDetails }, changeMissedNotificationList: Function, key: number) => {
    const voice_call_type = 'voice';
    const video_call_type = 'video';
    const kiosk_offline_call_type = 'kiosk-offline';
    const kiosk_online_call_type = 'kiosk-online';
    // console.log(notification, 'notification ==============>');

    let notificationDate = '';
    if (notification && notification.time) {
        const dateValue: Date = new Date(notification.time);
        const formattedTime: string =
            ("00" + (dateValue.getMonth() + 1)).slice(-2) +
            "/" +
            ("00" + dateValue.getDate()).slice(-2) +
            "/" +
            dateValue.getFullYear() +
            " " +
            ("00" + dateValue.getHours()).slice(-2) +
            ":" +
            ("00" + dateValue.getMinutes()).slice(-2) +
            ":" +
            ("00" + dateValue.getSeconds()).slice(-2);
        notificationDate = formattedTime;
    }

    return (
        (locations) ?
            <div className="navigation-location-details">
                <Card
                    className={"card mb-1"}
                    key={key}
                >
                    <Card.Body className="card-body">
                        {
                            <div className="row d-flex align-items-center">
                                <div className={"col-md-7"} >
                                    <div>
                                        <label className="d-inline-flex">
                                            {
                                                (notification.locationId) ?
                                                    <h4 className="text-uppercase">
                                                        {locations[notification.locationId]?.name}
                                                    </h4>
                                                    :
                                                    (notification.agent_name) ?
                                                        <h4 className="text-uppercase">
                                                            {notification.agent_name}
                                                        </h4>
                                                        :
                                                        <></>

                                            }
                                        </label>
                                        {
                                            (notificationDate) ?
                                                <div className="text-small mt-1">
                                                    {notificationDate}
                                                </div>
                                                :
                                                <></>
                                        }
                                        {
                                            (notification.locationId) ?
                                                <div className="text-small">
                                                    {locations[notification.locationId]?.state + ","} {" "}
                                                    {locations[notification.locationId]?.city}
                                                </div>
                                                :
                                                <></>
                                        }
                                        {
                                            (notification.agent_email) ?
                                                <div className="text-small">
                                                    {notification.agent_email}
                                                </div>
                                                :
                                                <></>
                                        }
                                    </div>
                                </div>
                                {notification.call_type === video_call_type &&
                                    <div className="col-md-2">
                                        <b>{notification.screenshot ? "Kiosk call" : (notification.callCategory === "qrScan" ? "QR Code" : "Website") + " call"}</b>
                                    </div>
                                }
                                {
                                    (notification && notification.call_type && notification.call_type === voice_call_type) ?
                                        <div className="col-md-3 addressInfo">
                                            {
                                                (notification.third_agent) ?
                                                    <i className={"bi bi-people-fill"}></i>
                                                    :
                                                    (notification.agent_email) ?
                                                        <i className="bi bi-person-plus-fill"></i>
                                                        :
                                                        <div>
                                                            <ul className="list-group list-group-flush">
                                                                <li className="list-group-item">
                                                                    <i className={"bi bi-telephone-inbound-fill"}></i> {" "}
                                                                </li>
                                                                {(notification.contact_from) ?
                                                                    <li className="list-group-item">
                                                                        < span className="text-small">
                                                                            +{notification.contact_from}
                                                                        </span>
                                                                    </li>
                                                                    :
                                                                    <></>
                                                                }
                                                            </ul>
                                                        </div>
                                            }
                                        </div>
                                        :
                                        (notification && notification.screenshot && notification.call_type === video_call_type) ?
                                            <div className="col-md-2">
                                                <img
                                                    src={notification.screenshot}
                                                    className="imageLogo"
                                                    width="100%"
                                                    height="auto"
                                                    alt="temp"
                                                />
                                            </div>
                                            :
                                            (notification && notification.call_type && [kiosk_online_call_type, kiosk_offline_call_type].includes(notification.call_type.toLocaleLowerCase())) ?
                                                <div className="col-md-3 addressInfo">
                                                    <div>
                                                        <ul className="list-group list-group-flush">
                                                            <li className="list-group-item">
                                                                <i className={(notification.call_type.toLocaleLowerCase() === kiosk_online_call_type) ? "bi bi-pc-display green-filled" : "bi bi-pc-display red-filled"}></i> {" "}
                                                            </li>
                                                            <li className="list-group-item">
                                                                < span className="text-small">
                                                                    {(notification.call_type.toLocaleLowerCase() === kiosk_online_call_type) ? "Kiosk online" : "Kiosk offline"}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                :
                                                <div className="col-md-2 addressInfo">
                                                    <i style={{ fontSize: '45px', paddingLeft: '20px' }} className={`${notification.callCategory === "qrScan" ? 'bi bi-qr-code' : 'bi bi-browser-chrome'}`}></i>
                                                </div>
                                }
                                <div className="col-md-1">
                                    <i className="bi bi-trash3-fill" onClick={() => { changeMissedNotificationList(notification); }}></i>
                                </div>
                            </div>
                        }
                    </Card.Body>
                </Card>
            </div >
            :
            <></>
    );
}

const NavigationBar = ({ emitAgentStatus }: NavigationBarDto) => {
    let settingsState = useAppSelector((state) => state.settings);
    let LoginUserDetails = useAppSelector((state) => state.auth.users);
    let authState = useAppSelector((state) => state.auth);
    // console.log(authState, 'authState')
    let notificationsSliceSelector = useAppSelector((state) => state.agentNotification);
    const [links, setLinks] = React.useState<DtoSettingsLinks>();
    const [userDetails, setUserDetails] = React.useState<any>();
    const [toggleNavbar, setToggleNavbar] = React.useState<boolean>(false);
    const [showMissedNotifications, setShowMissedNotifications] = React.useState<boolean>(false);
    const [showDeviceChoicePopup, setShowDeviceChoicePopup] = React.useState<boolean>(false);
    const [missedNotification, setMissedNotification] = React.useState<Array<DtoIncomingNotification>>((localStorage.getItem("missed_notification") && localStorage.getItem("missed_notification") != null) ? JSON.parse(localStorage.getItem("missed_notification")!) : []);
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [showVoiceMailIdentificationBell, setShowVoiceMailIdentificationBell] = React.useState(localStorage.getItem('voiceMailNotification'));

    React.useEffect(() => {
        if (settingsState.links) {
            let linksArray: DtoLinks[] = JSON.parse(settingsState.links);
            let otherLinks: DtoLinks[] = [];
            let mainLinks: DtoLinks[] = [];
            if (linksArray.length > 3) {
                mainLinks = linksArray.slice(0, 3);
                otherLinks = linksArray.slice(3, linksArray.length);
            } else {
                mainLinks = linksArray;
            }
            let settingsLinks = {
                extraSettingsMenus: otherLinks,
                mainSettingsMenus: mainLinks,
            };
            setLinks(Object.assign({}, settingsLinks));
        }
    }, [settingsState.links]);

    React.useEffect(() => {
        if (LoginUserDetails) {
            setUserDetails(LoginUserDetails);
        }
    }, [LoginUserDetails]);

    const changeMissedNotificationList = React.useCallback((missedNotification: DtoIncomingNotification | undefined) => {
        let missedNotificationArray: Array<DtoIncomingNotification> = [];
        if (missedNotification) {
            let missedNotificationLocalStorage: string | null = localStorage.getItem("missed_notification");
            if (missedNotificationLocalStorage) {
                missedNotificationArray = JSON.parse(missedNotificationLocalStorage);
            }
            missedNotificationArray = [...missedNotificationArray.filter((notification: DtoIncomingNotification) => notification.notificationId !== missedNotification.notificationId)];
        }
        localStorage.setItem("missed_notification", JSON.stringify(missedNotificationArray));
        dispatch(setMissedCallNotificationTrigger(true));
    }, [dispatch])

    const logout = React.useCallback(() => {
        loggerHelper("agent email", userDetails?.email);
        dispatch(setPreventNavigation(false));
        changeMissedNotificationList(undefined);
        disconnectWebSocketConnection();
        localStorage.clear();
        dispatch(clearAuthSlice());
        navigate("/");
    }, [changeMissedNotificationList, dispatch, navigate]);

    const checkMissedNotification = React.useCallback(() => {
        let missedNotificationLocalStorage: string | null = localStorage.getItem("missed_notification");
        let missedNotificationArray: Array<any> = [];
        if (missedNotificationLocalStorage) {
            missedNotificationArray = JSON.parse(missedNotificationLocalStorage);
        } else {
            missedNotificationArray = [];
        }
        setMissedNotification([...missedNotificationArray]);
    }, []);
    React.useEffect(() => {
        if (process.env.REACT_APP_ADMIN === localStorage.getItem("event")) {
            getSettingsDetails(true);
        } else {
            getSettingsDetails(false);
        }
    }, [setLinks]);


    React.useEffect(() => {
        if (notificationsSliceSelector.voiceMailNotificationTrigger) {
            setShowVoiceMailIdentificationBell(localStorage.getItem("voiceMailNotification"));
            dispatch(setVoiceMailNotificationTrigger(!notificationsSliceSelector.voiceMailNotificationTrigger));
        }
    }, [notificationsSliceSelector.voiceMailNotificationTrigger]);

    React.useEffect(() => {
        if (notificationsSliceSelector.missedNotificationTrigger) {
            checkMissedNotification();
            dispatch(setMissedCallNotificationTrigger(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notificationsSliceSelector.missedNotificationTrigger]);

    const confirmRedirectPage = React.useCallback((path: string) => {
        navigate(path);
        dispatch(setPreventNavigation(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const changeLocalDeviceConfiguration = (deviceType: any) => {
        dispatch(setAudioOutputDeviceChanged(true));
    }

    let documents: any =
    {
        agent: "customerAdminAgents",
        location: "customerAdminLocations",
        kiosk: "customerAdminKiosks",
        settings: "customerAdminSettings",
        admin_reports: "agentReport",
        reports: "agentReport",
        dashboard: "agentDashboard",
        team: "agentTeam"
    };

    const handleClick = (url: string) => {
        window.open(url, '_blank');
    }

    const openHelpDocs = (siteName: string) => {
        GetApiMethod(siteName === "admin" ? "admin/settings/getAllDocs" : "tenant/agent/getAllDocs").then((res: any) => {
            const url: string = res.data?.data?.Docs[documents[location.pathname?.slice(1)]];
            if (!url) {
                DisplayToaster(
                    "bg-danger",
                    "Document not available, please contact the administrator.",
                    '5000'
                )
            } else {
                React.createElement('a', { href: url, target: '_blank', onClick: handleClick(url) });
            }
        }).catch((error: any) => {
            console.log(error, 'error in help docs');
        })
    };

    return (
        <>
            <div className='pt-100'>
                <Navbar className="px-3 h-80 bg-lightgray"
                    expand={"lg"}
                    fixed="top"
                    collapseOnSelect
                >
                    <Container fluid>
                        <Navbar.Brand
                            onClick={() =>
                                navigate(
                                    process.env.REACT_APP_ADMIN ===
                                        localStorage.getItem("event")
                                        ? constant.AGENT_LIST
                                        : constant.AGENT_DASHBOARD
                                )
                            }
                            className="cursor-pointer"
                        >
                            <img
                                alt="RCM"
                                src={rcmlogo}
                                width="120"
                                height="auto"
                                className="d-inline-block align-top"
                            />
                        </Navbar.Brand>

                        <Badge
                            pill
                            bg=""
                            className="mx-2 py-2 px-3 header-badge-btn"
                        >
                            {userDetails &&
                                (userDetails.hasOwnProperty("role")
                                    ? "Customer Admin"
                                    : "Agent")}
                        </Badge>

                        <Navbar.Toggle
                            aria-controls={`offcanvasNavbar-expand-lg`}
                            onClick={() => {
                                setToggleNavbar(!toggleNavbar);
                            }}
                        />
                        <Navbar.Offcanvas
                            id={`offcanvasNavbar-expand-lg`}
                            aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
                            placement="top"
                            enforceFocus={true}
                            scroll={false}
                        >
                            <Offcanvas.Header closeButton>
                                <Offcanvas.Title
                                    id={`offcanvasNavbarLabel-expand-lg`}
                                >
                                    <img
                                        alt="RCM"
                                        src={rcmlogo}
                                        width="150"
                                        height="40"
                                        className="d-inline-block align-top"
                                    />
                                </Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                <Nav className="justify-content-start navigation-bar-nav flex-grow-1 left-menu">
                                    {process.env.REACT_APP_ADMIN ===
                                        localStorage.getItem("event") ? (
                                        <>
                                            <Nav.Link
                                                href="#"
                                                eventKey={
                                                    location.pathname ===
                                                        constant.AGENT_EDIT
                                                        ? constant.AGENT_EDIT
                                                        : location.pathname ===
                                                            constant.AGENT_CREATE
                                                            ? constant.AGENT_CREATE
                                                            : location.pathname ===
                                                                constant.AGENT_LIST
                                                                ? constant.AGENT_LIST
                                                                : "/agent"
                                                }
                                                onClick={() =>
                                                    navigate(
                                                        constant.AGENT_LIST
                                                    )
                                                }
                                                className={
                                                    location.pathname ===
                                                        constant.AGENT_EDIT ||
                                                        location.pathname ===
                                                        constant.AGENT_CREATE ||
                                                        location.pathname ===
                                                        constant.AGENT_LIST
                                                        ? "agent active"
                                                        : "agent"
                                                }
                                            >
                                                {" "}
                                                Agents{" "}
                                            </Nav.Link>
                                            <Nav.Link
                                                href="#"
                                                eventKey={
                                                    location.pathname ===
                                                        constant.LOCATION_CREATE
                                                        ? constant.LOCATION_CREATE
                                                        : location.pathname ===
                                                            constant.LOCATION_EDIT
                                                            ? constant.LOCATION_EDIT
                                                            : location.pathname ===
                                                                constant.LOCATION_LIST
                                                                ? constant.LOCATION_LIST
                                                                : "/location"
                                                }
                                                onClick={() =>
                                                    navigate(
                                                        constant.LOCATION_LIST
                                                    )
                                                }
                                                className={
                                                    location.pathname ===
                                                        constant.LOCATION_CREATE ||
                                                        location.pathname ===
                                                        constant.LOCATION_EDIT ||
                                                        location.pathname ===
                                                        constant.LOCATION_LIST
                                                        ? "location active"
                                                        : "location"
                                                }
                                            >
                                                {" "}
                                                Locations{" "}
                                            </Nav.Link>
                                            {userDetails &&
                                                userDetails.role ===
                                                "super_admin" ? (
                                                <Nav.Link
                                                    href="#"
                                                    eventKey={
                                                        location.pathname ===
                                                            constant.KIOSK_CREATE
                                                            ? constant.KIOSK_CREATE
                                                            : location.pathname ===
                                                                constant.KIOSK_EDIT
                                                                ? constant.KIOSK_EDIT
                                                                : location.pathname ===
                                                                    constant.KIOSK_LIST
                                                                    ? constant.KIOSK_LIST
                                                                    : "/kiosk"
                                                    }
                                                    onClick={() =>
                                                        navigate(
                                                            constant.KIOSK_LIST
                                                        )
                                                    }
                                                    className={
                                                        location.pathname ===
                                                            constant.KIOSK_CREATE ||
                                                            location.pathname ===
                                                            constant.KIOSK_EDIT ||
                                                            location.pathname ===
                                                            constant.KIOSK_LIST
                                                            ? "kiosk active"
                                                            : "kiosk"
                                                    }
                                                >
                                                    {" "}
                                                    Kiosks{" "}
                                                </Nav.Link>
                                            ) : (
                                                ""
                                            )}
                                            <Nav.Link
                                                href="#"
                                                eventKey={
                                                    location.pathname ===
                                                        constant.SETTING_EDIT
                                                        ? constant.SETTING_EDIT
                                                        : location.pathname ===
                                                            constant.SETTING
                                                            ? constant.SETTING
                                                            : "/settings"
                                                }
                                                onClick={() =>
                                                    navigate(constant.SETTING)
                                                }
                                                className={
                                                    location.pathname ===
                                                        constant.SETTING_EDIT ||
                                                        location.pathname ===
                                                        constant.SETTING
                                                        ? "setting active"
                                                        : "setting"
                                                }
                                            >
                                                {" "}
                                                Settings{" "}
                                            </Nav.Link>
                                            <Nav.Link
                                                eventKey={constant.ADMIN_VOICEMAIL_REPORT}
                                                onClick={() =>
                                                    navigate(constant.ADMIN_VOICEMAIL_REPORT)
                                                }
                                                active={
                                                    location.pathname ===
                                                        constant.ADMIN_VOICEMAIL_REPORT
                                                        ? true
                                                        : false
                                                }
                                            >
                                                {" "}
                                                Voicemail{" "}
                                                {
                                                    (showVoiceMailIdentificationBell !== "0" && showVoiceMailIdentificationBell !== "null") && <span className="badge badge-pill badge-danger" style={{ fontSize: "12px", borderRadius: '50%' }}>{showVoiceMailIdentificationBell}</span>
                                                }
                                            </Nav.Link>
                                            <Nav.Link
                                                href="#"
                                                eventKey={constant.ADMIN_REPORT}
                                                onClick={() =>
                                                    navigate(
                                                        constant.ADMIN_REPORT
                                                    )
                                                }
                                                className={
                                                    location.pathname ===
                                                        constant.ADMIN_REPORT
                                                        ? "reports active"
                                                        : "reports"
                                                }
                                            >
                                                {" "}
                                                Report{" "}
                                            </Nav.Link>
                                            <Nav.Link
                                                href="#"
                                                onClick={() =>
                                                    openHelpDocs('admin')
                                                }
                                            >
                                                {" "}
                                                Help{" "}
                                            </Nav.Link>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {process.env.REACT_APP_AGENT ===
                                        localStorage.getItem("event") ? (
                                        <>
                                            <Nav.Link
                                                eventKey={
                                                    constant.AGENT_DASHBOARD
                                                }
                                                onClick={() =>
                                                    navigate(
                                                        constant.AGENT_DASHBOARD
                                                    )
                                                }
                                                active={
                                                    location.pathname ===
                                                        constant.AGENT_DASHBOARD
                                                        ? true
                                                        : false
                                                }
                                            >
                                                {" "}
                                                Dashboard{" "}
                                            </Nav.Link>

                                            <Nav.Link
                                                eventKey={constant.AGENT_TEAM}
                                                onClick={() =>
                                                    location.pathname ===
                                                        constant.AGENT_DASHBOARD &&
                                                        authState.preventNavigation
                                                        ? window.confirm(
                                                            `Are you sure you want to go to team page? Notification and call connection will be destroyed.`
                                                        ) &&
                                                        confirmRedirectPage(
                                                            constant.AGENT_TEAM
                                                        )
                                                        : navigate(
                                                            constant.AGENT_TEAM
                                                        )
                                                }
                                                active={
                                                    location.pathname ===
                                                        constant.AGENT_TEAM
                                                        ? true
                                                        : false
                                                }
                                            >
                                                {" "}
                                                Team{" "}
                                            </Nav.Link>
                                            <Nav.Link
                                                eventKey={constant.VOICEMAIL_REPORT}
                                                onClick={() =>
                                                    location.pathname ===
                                                        constant.AGENT_DASHBOARD &&
                                                        authState.preventNavigation
                                                        ? window.confirm(
                                                            `Are you sure you want to go to team page? Notification and call connection will be destroyed.`
                                                        ) &&
                                                        confirmRedirectPage(
                                                            constant.VOICEMAIL_REPORT
                                                        )
                                                        : navigate(
                                                            constant.VOICEMAIL_REPORT
                                                        )
                                                }
                                                active={
                                                    location.pathname ===
                                                        constant.VOICEMAIL_REPORT
                                                        ? true
                                                        : false
                                                }
                                            >
                                                {" "}
                                                Voicemail{" "}
                                                {
                                                    (showVoiceMailIdentificationBell !== "0" && showVoiceMailIdentificationBell !== "null") && <span className="badge badge-pill badge-danger" style={{ fontSize: "12px", borderRadius: '50%' }}>{showVoiceMailIdentificationBell}</span>
                                                }
                                            </Nav.Link>
                                            <Nav.Link
                                                eventKey={constant.AGENT_REPORT}
                                                onClick={() =>
                                                    location.pathname ===
                                                        constant.AGENT_DASHBOARD &&
                                                        authState.preventNavigation
                                                        ? window.confirm(
                                                            `Are you sure you want to go to team page? Notification and call connection will be destroyed.`
                                                        ) &&
                                                        confirmRedirectPage(
                                                            constant.AGENT_REPORT
                                                        )
                                                        : navigate(
                                                            constant.AGENT_REPORT
                                                        )
                                                }
                                                active={
                                                    location.pathname ===
                                                        constant.AGENT_REPORT
                                                        ? true
                                                        : false
                                                }
                                            >
                                                {" "}
                                                Report{" "}
                                            </Nav.Link>
                                            <Nav.Link
                                                href="#"
                                                onClick={() =>
                                                    openHelpDocs('agent')
                                                }
                                            >
                                                {" "}
                                                Help{" "}
                                            </Nav.Link>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </Nav>


                            </Offcanvas.Body>

                        </Navbar.Offcanvas>

                    </Container>
                    <Nav className="sub-navigation justify-content-end align-items-center gap-1 navigation-bar-nav flex-grow-1">
                        {/* <Button className="m-4 buttons app-button-color" title="Help Docs" onClick={(e) => { }}><i className="bi bi-file-text-fill"></i></Button> */}
                        {links &&
                            links["mainSettingsMenus"].length ? (
                            links["mainSettingsMenus"].map(
                                (item: DtoLinks, i: any) => {
                                    return (
                                        <a
                                            className="me-2 app-link-color navigation-bar-nav-app-link-color"
                                            href={Object.values(
                                                item
                                            ).toString()}
                                            target="_blank"
                                            key={
                                                Object.values(
                                                    item
                                                ).toString() + i
                                            } rel="noreferrer"
                                        >
                                            {" "}
                                            {Object.keys(item)}{" "}
                                        </a>
                                    );
                                }
                            )
                        ) : (
                            <></>
                        )}

                        {links &&
                            links["extraSettingsMenus"].length > 0 ? (
                            <NavDropdown
                                title="Links"
                                id="navbarScrollingDropdown"
                                className={
                                    "active navigation-bar-nav"
                                }
                            >
                                {links["extraSettingsMenus"].map(
                                    (item: DtoLinks, i: any) => {
                                        return (
                                            <NavDropdown.Item
                                                href={Object.values(
                                                    item
                                                ).toString()}
                                                target="_blank"
                                                key={
                                                    Object.values(
                                                        item
                                                    ).toString() + i
                                                }
                                            >
                                                {Object.keys(item)}
                                            </NavDropdown.Item>
                                        );
                                    }
                                )}
                            </NavDropdown>
                        ) : (
                            <></>
                        )}
                        {process.env.REACT_APP_ADMIN !==
                            localStorage.getItem("event") && (
                                <>
                                    <Nav.Link
                                        eventKey={constant.AGENT_REPORT}
                                        onClick={() => { setShowMissedNotifications(true) }}
                                        className="missed-notification"
                                    >
                                        {" "}
                                        <i className="bi bi-bell-fill position-relative" title="Missed Notifications List">
                                            {
                                                (missedNotification?.length) ?
                                                    <span className="position-absolute top-2 start-100 translate-middle badge rounded-pill badge-danger">{(missedNotification && missedNotification.length) ? missedNotification.length : 0}</span>
                                                    :
                                                    <></>
                                            }
                                        </i>
                                        {" "}
                                    </Nav.Link>

                                    <Nav.Link
                                        onClick={() => { setShowDeviceChoicePopup(true) }}
                                        className=""
                                    >
                                        {" "}
                                        <i className="bi bi-gear-fill" title="Device Choice" style={{ fontSize: "20px" }}>
                                        </i>
                                        {" "}
                                    </Nav.Link>

                                    <NavDropdown
                                        title={
                                            <span className="ml-2 user-status">
                                                <span
                                                    className={
                                                        authState.agentStatus
                                                            ? authState.agentStatus
                                                            : "offline"
                                                    }
                                                ></span>
                                                <span>
                                                    {
                                                        AgentStatusKeyValue[
                                                        authState
                                                            .agentStatus
                                                        ]
                                                    }
                                                </span>
                                            </span>
                                        }
                                        id="navbarScrollingDropdown"
                                        className={
                                            "active navigation-bar-nav agent-status-list text-capitalize active-status"
                                        }
                                        disabled={
                                            authState.agentStatus &&
                                                authState.agentStatus === "busy"
                                                ? true
                                                : false
                                        }
                                    >
                                        <NavDropdown.Item
                                            onClick={() =>
                                                emitAgentStatus("online")
                                            }
                                        >
                                            <span className="ml-2">
                                                <span className="online"></span>
                                                <span className="ml-1">
                                                    Online
                                                </span>
                                            </span>
                                        </NavDropdown.Item>
                                        <NavDropdown.Item
                                            onClick={() =>
                                                emitAgentStatus("away")
                                            }
                                        >
                                            <span className="ml-2">
                                                <span className="away"></span>
                                                <span className="ml-1">
                                                    Be right back
                                                </span>
                                            </span>
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </>
                            )}

                        <NavDropdown
                            align="end"
                            className=""
                            title={
                                <i
                                    className="bi bi-person-circle"
                                    style={{
                                        fontSize: 35,
                                        color: "#0187c4",
                                    }}
                                ></i>
                            }
                        >
                            <NavDropdown.Item>
                                <h5>{userDetails?.name}</h5>
                                <label className="text-small">
                                    {userDetails?.email}
                                </label>
                            </NavDropdown.Item>
                            <NavDropdown.Item
                                className="text-primary"
                                onClick={() =>
                                    location.pathname ===
                                        constant.AGENT_DASHBOARD &&
                                        authState.preventNavigation
                                        ? window.confirm(
                                            `Are you sure you want to logout? Notification and call connection will be destroyed.`
                                        ) && logout()
                                        : logout()
                                }
                            >
                                <Button className="btn btn-sm">
                                    <i className="bi bi-box-arrow-in-right"></i>{" "}
                                    Logout
                                </Button>
                            </NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                </Navbar>

                {(showMissedNotifications) ?
                    <AppModal
                        title={"Missed Notifications"}
                        bodyText={""}
                        showCloseButton={true}
                        closeButtonEventEmitter={() => { setShowMissedNotifications(false); }}
                        primaryButtonLabel={"Clear all"}
                        primaryButtonEventEmitter={() => { changeMissedNotificationList(undefined); setShowMissedNotifications(false); }}
                        bodyClassName={"navigation-location-details-modal-body"}
                        modalSize={"lg"}
                    >
                        {
                            (missedNotification && missedNotification.length) ?
                                <>
                                    {
                                        missedNotification.map((notification: DtoIncomingNotification, index: number) => {
                                            return (
                                                notificationDetails(notification, notificationsSliceSelector.locationDetails, changeMissedNotificationList, index)
                                            );
                                        }
                                        )
                                    }
                                </>
                                :
                                <>No Notifications</>
                        }
                    </AppModal>
                    :
                    <></>
                }

                {
                    (showDeviceChoicePopup) ?
                        <AppModal
                            title={"Device Choice"}
                            bodyText={""}
                            showCloseButton={true}
                            primaryButtonLabel={"Close"}
                            primaryButtonEventEmitter={() => { setShowDeviceChoicePopup(false); }}
                            closeButtonEventEmitter={() => { setShowDeviceChoicePopup(false); }}
                        >
                            <DeviceChoice deviceChangeFlag={true} deviceChangeCallBackFunction={(deviceType: any) => { changeLocalDeviceConfiguration(deviceType) }} />
                        </AppModal>
                        :
                        <></>
                }

            </div>
        </>
    );
};

export default NavigationBar;
